import React from "react";
import { InfoItem } from "./modules/InfoItem/InfoItem";

export const KeyDetails = ({ className, keyDetails }) => {
  return (
    <div className={className}>
      <div className="tw-text-[#4f4e5c] tw-text-[0.875rem] tw-font-medium tw-leading-[28px]">
        <span className="tw-text-[#493ab1]">Key details to check</span> before
        you connect..
      </div>

      <div className="tw-flex tw-flex-col tw-gap-[9px] tw-mt-[10px]">
        {keyDetails.map(({ id, label }) => (
          <InfoItem key={id} label={label} />
        ))}
      </div>
    </div>
  );
};
